import { useState, useEffect } from "react";
import { roleAPI } from "../rolesService";
import { handleApiError } from "../../../../services/axiosService";
import { toastError, toastSuccess } from "../../../../utils/toastUtils";

export const useRoles = (orgId) => {
  const [roles, setRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchRoles = async () => {
    try {
      setIsLoading(true);
      const response = await roleAPI.getAll(orgId);
      setRoles(response.data || []);
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const createRole = async (data) => {
    if (!data.name || !data.role_code) {
      toastError("Please fill required fields");
      return false;
    }

    try {
      const response = await roleAPI.create(orgId, data);
      setRoles([...roles, response.data]);
      toastSuccess("Role created successfully");
      return true;
    } catch (error) {
      toastError("Failed to create role");
      console.error(error);
      return false;
    }
  };

  const updateRole = async (id, data) => {
    if (!data.name || !data.role_code) {
      toastError("Please fill required fields");
      return false;
    }

    try {
      const response = await roleAPI.update(id, orgId, data);
      console.log(response);
      setRoles(roles.map((r) => (r.id === id ? response.data : r)));
      toastSuccess("Role updated successfully");
      return true;
    } catch (error) {
      toastError("Failed to update role");
      console.error(error);
      return false;
    }
  };

  const deleteRole = async (id) => {
    try {
      await roleAPI.delete(id);
      setRoles((prev) => prev.filter((r) => r.id !== id));
      toastSuccess("Role deleted successfully");
      return true;
    } catch (error) {
      toastError("Failed to delete role");
      console.error(error);
      return false;
    }
  };

  useEffect(() => {
    fetchRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);

  return {
    roles,
    isLoading,
    createRole,
    updateRole,
    deleteRole,
    refreshRoles: fetchRoles
  };
};
